import history from '../../util/history'

const hideDetailView = () => {
  history.push('/plan')

  return true
}

export default hideDetailView
